module.exports = __webpack_public_path__ + "static/img/mobile-app.fd241b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app/mobile-app.svg
// module id = B3yo
// module chunks = 1